import script from "./BidModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BidModal.vue?vue&type=script&setup=true&lang=js"

import "./BidModal.vue?vue&type=style&index=0&id=53e7fd4a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e7fd4a"]])

export default __exports__